import { render, staticRenderFns } from "./examinationArchives.vue?vue&type=template&id=3cb17026&scoped=true"
import script from "./examinationArchives.vue?vue&type=script&lang=js"
export * from "./examinationArchives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb17026",
  null
  
)

export default component.exports